<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>
    <v-card
      width="450px">
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-auto-complete
            v-model="filtros.idContratista"
            label="Contratista"
            class="my-1"
            :items="contratistas"
            item-text="nombreRazonSocial"
            item-value="id"
            clearable
            hide-details>
          </custom-auto-complete>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';

export default {
  name: 'FiltrosAdjudicaciones',
  components: {
    CustomAutoComplete,
  },
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    catalogoContratistas: {
      query: CONTRATISTAS,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  computed: {
    contratistas() {
      if (!this.catalogoContratistas || this.catalogoContratistas.length <= 0) return [];

      return this.catalogoContratistas.slice()
        .sort((a, b) => (`${a.nombreRazonSocial}`).localeCompare(b.nombreRazonSocial));
    },
  },
};
</script>

<style lang="scss">
</style>
